import { takeLast } from 'ramda';

import logo from './images/logo.svg';
import document from './images/document.svg';
import watch from './images/watch.svg';
import plane from './images/plane.svg';
import video from './images/video.svg';
import point from './images/point.svg';
import mail from './images/mail.svg';
import done from './images/done.svg';
import play from './images/play.svg';
import pause from './images/pause.svg';
import close from './images/close.svg';
import message from './images/message.svg';
import checked from './images/checked.svg';
import unchecked from './images/unchecked.svg';
import home from './images/home.svg';
import questionMark from './images/questionMark.svg';
import account from './images/account.svg';
import forwardArrow from './images/forwardArrow.svg';
import backArrow from './images/backArrow.svg';
import downArrow from './images/downArrow.svg';
import plus from './images/plus.svg';
import minus from './images/minus.svg';
import menu from './images/menu.svg';
import retake from './images/retake.svg';
import visible from './images/visible.svg';
import visibleOff from './images/visibleOff.svg';
import star from './images/star.svg';
import contourStar from './images/contourStar.svg';
import task from './images/task.svg';
import conversation from './images/conversation.svg';
import lock from './images/lock.svg';
import linkedin from './images/linkedin.svg';
import expandMore from './images/expandMore.svg';
import expandLess from './images/expandLess.svg';
import expandMoreBetter from './images/expandMoreBetter.svg';
import expandLessWorse from './images/expandLessWorse.svg';
import questionAnswer from './images/questionAnswer.svg';
import arrow from './images/arrow.svg';
import attach from './images/attach.svg';
import save from './images/save.svg';
import compare from './images/compare.svg';
import startOver from './images/startOver.svg';
import twitter from './images/twitter.svg';
import facebook from './images/facebook.svg';
import ehoLogo from './images/ehoLogo.svg';
import burger from './images/burger.svg';
import bigClose from './images/bigClose.svg';
import linkedinTeal from './images/linkedinTeal.svg';
import deleteValue from './images/deleteValue.svg';
import saveWhite from './images/saveWhite.svg';
import add from './images/add.svg';
import grayLogo from './images/grayLogo.svg';
import searchLens from './images/searchLens.svg';
import check from './images/check.svg';
import agents from './images/agents.svg';
import info from './images/info.svg';

const getIconDimensions = viewbox => {
  const [width, height] = takeLast(2, viewbox.split(' '));

  return {
    width,
    height,
  };
};

const getIconAttributes = name => {
  const { width, height } = getIconDimensions(name.viewBox);

  return {
    src: name,
    viewBox: name.viewBox,
    id: `#${name.id}`,
    width,
    height,
  };
};

export default {
  logo: getIconAttributes(logo),
  document: getIconAttributes(document),
  watch: getIconAttributes(watch),
  plane: getIconAttributes(plane),
  video: getIconAttributes(video),
  point: getIconAttributes(point),
  mail: getIconAttributes(mail),
  done: getIconAttributes(done),
  play: getIconAttributes(play),
  pause: getIconAttributes(pause),
  close: getIconAttributes(close),
  message: getIconAttributes(message),
  checked: getIconAttributes(checked),
  unchecked: getIconAttributes(unchecked),
  home: getIconAttributes(home),
  questionMark: getIconAttributes(questionMark),
  account: getIconAttributes(account),
  forwardArrow: getIconAttributes(forwardArrow),
  backArrow: getIconAttributes(backArrow),
  downArrow: getIconAttributes(downArrow),
  plus: getIconAttributes(plus),
  minus: getIconAttributes(minus),
  menu: getIconAttributes(menu),
  retake: getIconAttributes(retake),
  visibleOff: getIconAttributes(visibleOff),
  visible: getIconAttributes(visible),
  star: getIconAttributes(star),
  contourStar: getIconAttributes(contourStar),
  conversation: getIconAttributes(conversation),
  task: getIconAttributes(task),
  lock: getIconAttributes(lock),
  linkedin: getIconAttributes(linkedin),
  expandMore: getIconAttributes(expandMore),
  expandLess: getIconAttributes(expandLess),
  expandMoreBetter: getIconAttributes(expandMoreBetter),
  expandLessWorse: getIconAttributes(expandLessWorse),
  questionAnswer: getIconAttributes(questionAnswer),
  arrow: getIconAttributes(arrow),
  attach: getIconAttributes(attach),
  save: getIconAttributes(save),
  compare: getIconAttributes(compare),
  startOver: getIconAttributes(startOver),
  twitter: getIconAttributes(twitter),
  facebook: getIconAttributes(facebook),
  ehoLogo: getIconAttributes(ehoLogo),
  burger: getIconAttributes(burger),
  bigClose: getIconAttributes(bigClose),
  linkedinTeal: getIconAttributes(linkedinTeal),
  deleteValue: getIconAttributes(deleteValue),
  saveWhite: getIconAttributes(saveWhite),
  add: getIconAttributes(add),
  grayLogo: getIconAttributes(grayLogo),
  searchLens: getIconAttributes(searchLens),
  check: getIconAttributes(check),
  agents: getIconAttributes(agents),
  info: getIconAttributes(info),
};



// WEBPACK FOOTER //
// ./src/sharedComponents/Icon/dictionary.js